import { observer } from 'mobx-react'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import TransactionDataGridForm from '../../../components/forms/TransactionDataGridForm'
import useTransactionForm from '../../../hooks/useTransactionForm'
import { Box, Typography } from '@material-ui/core'
import { Button } from '@rfh/ui'
import { toJS } from 'mobx'

const Returning_2: FC<unknown> = () => {
  const { t } = useTranslation()
  const { formStepsStore, isEditMode } = useTransactionForm('returning')

  const rows = formStepsStore.formData.transaction.rows
  const allRowsEmpty = toJS(rows).every(row => !row.col1.value)

  return (
    <>
      {allRowsEmpty && isEditMode ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingBottom: '6px',
          }}
        >
          <Typography variant='body1' style={{ paddingTop: '6px', marginRight: '6px' }}>
            {t('general:pageReload')}
          </Typography>
          <Button variant='text--underlined' onClick={() => window.location.reload()}>
            {t('general:pageReloadButton')}
          </Button>
        </Box>
      ) : null}
      <TransactionDataGridForm formStepsStore={formStepsStore} />
    </>
  )
}
export default observer(Returning_2)
